import { motion, useScroll, useTransform } from "framer-motion";

// ─────────────────────────────────────────────────────────────────────
// Data
// ─────────────────────────────────────────────────────────────────────

export const projects = [
  {
    name: "Encrypted IM App",
    description:
      "An messaging app that uses asymmetric encryption to provide confidentiality and integrity between participants.",
    tags: ["Python", "Cryptography", "Socket Programming"],
  },
  {
    name: "A2Empowerment",
    description:
      "A website that enables A2Empowerment to create, manage, and share forms with their tutoring partners in Cameroon.",
    tags: ["React", "Express", "MongoDB"],
  },
  {
    name: "TinyAES",
    description:
      "An implementation of the AES block encryption standard in C.",
    url: "https://github.com/William-Soylemez/TinyAES",
    tags: ["C", "Cryptography"],
  },
  {
    name: "Tufts Dining",
    description:
      "My first experience with React development! An improvement of the menus at Tufts University which is faster and more user-friendly than the original.",
    url: "https://tuftsdining.com",
    tags: ["React", "Google Firebase"],
  },
  {
    name: "Movie Recommendation System",
    description:
      "Created a model for recommending new movies to a user based on their previous preferences, allowing them to discover new films they enjoy",
    tags: ["Machine Learning", "Recommendation Systems", "Python"],
  },
];

export const experience = [
  {
    role: "Software Engineering Intern",
    company: "Microsoft",
    period: "May 2025 - Aug 2025",
    description:
      "Worked with the Azure Core team to enhance a diagnostic tool with dynamic information about BareMetal resources, improving engineers' ability to resolve networking issues",
  },
  {
    role: "Software Developer Intern",
    company: "MassEnergize",
    period: "May 2024 - Aug 2024",
    description:
      "Developed and launched an app using React Native that enabled communities in Massachusetts to share events and track progress on sustainability goals, streamlining the user experience over the website portal",
  },
  {
    role: "Head of Engineering / former Tech Lead",
    company: "JumboCode",
    period: "Sep 2023 - present",
    description:
      "Led a team of 10 developers in the creation of a web app for A2Empowerment (see details below). Next will manage technology for the entire club, encompassing 12 teams and 140 members.",
  },
];

export const stats = [
  { label: "Projects", value: 5, suffix: "+" },
  { label: "Internships", value: 3, suffix: "" },
  { label: "Members Led", value: 140, suffix: "" },
];

// ─────────────────────────────────────────────────────────────────────
// Motion Variants
// ─────────────────────────────────────────────────────────────────────

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.12 * i,
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

export const scaleIn = {
  hidden: { opacity: 0, y: 30, scale: 0.95 },
  show: (i = 1) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: 0.1 * i,
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

// ─────────────────────────────────────────────────────────────────────
// Shared Components
// ─────────────────────────────────────────────────────────────────────

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const width = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  return (
    <motion.div
      style={{ width }}
      className="fixed top-0 left-0 h-[2px] bg-gradient-to-r from-indigo-400 via-purple-500 to-pink-500 z-50"
    />
  );
};
